function config($logProvider) {
    'ngInject';

    $logProvider.debugEnabled(true);
}

export default config;


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/main.config.js